import { Link } from "react-router-dom";
import EnlaceCotizar from "../components/ui/EnlaceCotizar.jsx";
import Foto from "../components/ui/Foto.jsx";
import { useServicios } from "../lib/useCatalogo";
import { MAQUINAS } from "../lib/config";
import p from "./Pagina.module.css";

export default function Servicios() {
  const { servicios } = useServicios();

  return (
    <>
      <header className={p.cabecera}>
        <div className="container">
          <p className="eyebrow">Servicios</p>
          <h1 className={p.titulo}>Corte, plegado y rolado de plancha</h1>
          <p className={p.subtitulo}>
            Transformamos el acero a la medida de tu plano. Puedes traer tu
            propio material o comprarlo aqui mismo.
          </p>
        </div>
      </header>

      <section className={`container ${p.cuerpo}`}>
        <div className={p.grid}>
          {servicios.map((sv, i) => (
            <article key={sv.id} className={p.tarjeta}>
              <span className={p.tarjetaNum}>
                {String(i + 1).padStart(2, "0")}
              </span>
              <h2 className={p.tarjetaTitulo}>{sv.nombre}</h2>
              <p className={p.tarjetaTexto}>{sv.resumen}</p>
              {sv.detalle && <p className={p.tarjetaDetalle}>{sv.detalle}</p>}
            </article>
          ))}
        </div>

      </section>

      <section className="section section--surface">
        <div className="container">
          <p className="eyebrow">Maquinaria</p>
          <h2>El trabajo se hace en nuestra planta</h2>

          <div className={p.grid} style={{ marginTop: "2rem" }}>
            {MAQUINAS.map((m) => (
              <figure key={m.id} className={p.tarjeta} style={{ padding: 0, overflow: "hidden" }}>
                <Foto
                  nombre={m.id}
                  alt={m.nombre}
                  className={p.tarjetaFoto}
                  sizes="(max-width: 700px) 100vw, 50vw"
                />
                <figcaption style={{ padding: "1.25rem", display: "grid", gap: "0.4rem" }}>
                  <h3 className={p.tarjetaTitulo}>{m.nombre}</h3>
                  <p className={p.tarjetaTexto}>{m.descripcion}</p>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      <section className={`container ${p.cuerpo}`}>
        <p className="eyebrow">Como pedir un trabajo</p>
        <h2>Que necesitamos de ti</h2>

        <div className={p.grid} style={{ marginTop: "2rem" }}>
          {[
            {
              titulo: "El plano o la muestra",
              texto:
                "Un DXF es lo ideal para corte laser. Tambien trabajamos con PDF acotado, croquis a mano o la pieza fisica de referencia.",
            },
            {
              titulo: "Material y espesor",
              texto:
                "Si ya sabes que plancha necesitas, indicalo. Si no, lo definimos juntos segun el uso de la pieza.",
            },
            {
              titulo: "Cantidad y plazo",
              texto:
                "Cuantas piezas y para cuando. El plazo cambia bastante entre una unidad y una serie.",
            },
            {
              titulo: "Quien pone el acero",
              texto:
                "Puedes traer tu propio material o comprarlo con nosotros. En el segundo caso la cotizacion sale con todo incluido.",
            },
          ].map((item, i) => (
            <article key={item.titulo} className={p.tarjeta}>
              <span className={p.tarjetaNum}>
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className={p.tarjetaTitulo}>{item.titulo}</h3>
              <p className={p.tarjetaTexto}>{item.texto}</p>
            </article>
          ))}
        </div>
      </section>

      <section className={`container ${p.cuerpo}`} style={{ paddingTop: 0 }}>
        <div className={p.centrado} style={{ marginInline: 0, maxWidth: "58ch" }}>
          <h2>Cotiza tu pieza</h2>
          <p className={p.tarjetaTexto}>
            Envianos el plano y el detalle del trabajo. Te respondemos con
            precio, proceso y plazo.
          </p>
          <div className={p.acciones}>
            <EnlaceCotizar className="btn btn--accent">
              Pedir cotizacion
            </EnlaceCotizar>
            <Link to="/contacto" className="btn btn--ghost">
              Hablar con un asesor
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
